
import { useEffect, useRef, type ReactNode } from "react";
import { useDeck } from "./SectionDeck";
import styles from "./deck.module.css";

interface DeckSectionProps {
  index: number;
  children: ReactNode;
  className?: string;
  innerClassName?: string;
  /** Render content directly without the centered inner wrapper. */
  bare?: boolean;
  /** Scroll gestures this section takes before the deck moves on (default 1).
      The section reads `activeStep` from useDeck() and animates itself. */
  steps?: number;
}

export default function DeckSection({
  index,
  children,
  className,
  innerClassName,
  bare = false,
  steps = 1,
}: DeckSectionProps) {
  const { registerSection } = useDeck();
  const sectionRef = useRef<HTMLElement | null>(null);

  /* Register with the deck on mount so the scroll engine can target this section. */
  useEffect(() => {
    if (sectionRef.current) registerSection(index, steps)(sectionRef.current);
  }, [index, steps, registerSection]);

  return (
    <section
      ref={sectionRef}
      className={`${styles.section} ${className ?? ""}`}
    >
      {bare ? (
        children
      ) : (
        <div className={`${styles.sectionInner} ${innerClassName ?? ""}`}>
          {children}
        </div>
      )}
    </section>
  );
}
